import styled from 'styled-components';

const FilterTitle = styled.span`
  text-transform: uppercase;
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '15px')};
  padding: ${({ padding }) => (padding ? `${padding}px` : '0')};
  font-family: "${({ bold }) => (bold ? '"Avenir Black", "Arial Black"' : '"Avenir Light", "Arial"')}', sans-serif;
  ${({ noSpacing }) => (noSpacing ? null : 'letter-spacing: 1px;')};
`;

export default FilterTitle;
